import React from "react";

// Array of logo URLs (import or require your images accordingly)
const logos = [
  "/brand/cashfree.png",
  "/brand/aws.png",
  "/brand/google.svg",
  "/brand/andrew.jpeg",
  "/brand/phonepe.svg",
  "/brand/zeedone.png",
  "/brand/cumma.webp",
  "/brand/ducktail_black.png",
  "/brand/flixbus.png",
  "/brand/tailx.png",
];

function LogoSlider() {
  // Increase logo dimensions: Tailwind w-40 (160px) and gap-6 (24px)
  const logoWidth = 160;
  const gapWidth = 24;
  const totalWidth = logos.length * (logoWidth + gapWidth);
  const animationDuration = totalWidth / 60; // adjust speed

  return (
    <div className="w-full overflow-hidden relative py-12">
      {/* Section Title */}
      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold leading-tight mt-2 text-center mb-6 animate-fadeIn">
        <span className="text-[#fd3e3d]">
          Our Partners
        </span>
      </h1>

      {/* Left fade overlay */}
      <div className="absolute inset-y-0 left-0 w-32 z-10 bg-gradient-to-r from-white to-transparent pointer-events-none" />
      {/* Right fade overlay */}
      <div className="absolute inset-y-0 right-0 w-32 z-10 bg-gradient-to-l from-white to-transparent pointer-events-none" />

      {/* Slider animation keyframes */}
      <style>{`
        @keyframes logo-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${totalWidth}px); }
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="relative">
        <div
          className="flex items-center gap-6 will-change-transform"
          style={{
            animation: `logo-scroll ${animationDuration}s linear infinite`,
          }}
        >
          {/* Duplicate logos to loop smoothly */}
          {[...Array(3)].map((_, copyIndex) => (
            <React.Fragment key={copyIndex}>
              {logos.map((src, idx) => (
                <div key={`${copyIndex}-${idx}`} className="flex-none  h-auto" style={{ width: `200px` }}>
                  <img
                    src={src}
                    alt={`logo-${idx}`}
                    className="object-contain w-full h-full"
                  />
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogoSlider;
